<template>
	<div :class="{ portrait: !!portraitUrl }">
		<img fetchpriority="low" loading="lazy" :src="portraitUrl ?? NO_PORTRAIT_URL" :alt="name" />
	</div>
</template>

<script setup lang="ts">
// we there is a very old, but dedicated (square) portrait image profile S150 and S300.
// back then, we had a portrait format in the design, not a round square one.
// with the new images we ingested, the centering of the portrait image profile is off and cuts off the head.
// that's why we this component encapsulates this problem and makes it perfect for square profile pictures.
defineProps<{
	portraitUrl?: string;
	name: string;
}>();

const NO_PORTRAIT_URL = '/appassets/img/no-actor-transparent.png';
</script>

<style lang="scss" scoped>
.portrait {
	border-radius: 50%;
	height: 100%;
	width: 100%;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
